var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSmallClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.2.803a.664.664 0 00-.94 0L5 4.056 1.74.796a.665.665 0 00-.94.94l3.26 3.26L.8 8.256a.665.665 0 00.94.94L5 5.936l3.26 3.26a.665.665 0 00.94-.94l-3.26-3.26 3.26-3.26a.668.668 0 000-.933z",
    fill: "gray"
  })));
}

export default SvgIconSmallClose;